import queryKeys from '@/constants/queryKeys';
import {
  publicContentCreatorApplicationMeGet,
  TVerifyContentCreatorApplicationBody,
} from '@/services/api/requests/contentCreatorApplications';
import { useQuery } from '@tanstack/react-query';

const usePublicContentCreatorApplicationMe = (credentials: TVerifyContentCreatorApplicationBody, enabled = true) => {
  const { data, isError, isFetching, isLoading } = useQuery({
    queryKey: [queryKeys.contentCreatorApplications.publicMe, credentials.email, credentials.token],
    queryFn: () => publicContentCreatorApplicationMeGet(credentials),
    enabled: enabled && Boolean(credentials.email && credentials.token),
  });

  return {
    application: data,
    isError,
    isFetching,
    isLoading,
  };
};

export default usePublicContentCreatorApplicationMe;
